export const afterTrialBannerModalStyles = {
    content: {
        overflow: "hidden",
        padding: "0",
        border: "unset",
        width: "936px",
    },
};
